<template>
  <div class="token-ecosystem bg--color-02">
    <div class="container-wrapper bg--color-01">
      <div class="token-ecosystem__container container-new">
        <h5
          class="token-ecosystem__title txt--bold txt--36px txt--44px--l txt--height--44px txt--height--58px--l txt--color-04 mb-0"
        >
          {{ $t('business.tokenEcosystem.title') }}
        </h5>
        <img
          class="token-ecosystem__image"
          src="@/assets/img/business/token-ecosystem/ecosystem.svg"
          width="90%"
          alt="ecosystem image"
        >
        <img
          class="token-ecosystem__image-desktop"
          src="@/assets/img/business/token-ecosystem/ecosystem--desktop.svg"
          width="90%"
          alt="ecosystem image"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TokenEcosystem',
}
</script>

<style lang="scss" scoped>
.token-ecosystem {
  &__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: toRem(16px);

    @include bp(m) {
      gap: toRem(40px);
    }
  }

  &__image {
    max-width: toRem(344px);

    @include bp(m) {
      display: none;
    }
  }

  &__image-desktop {
    max-width: toRem(940px);

    @include bp(0, m) {
      display: none;
    }
  }
}
</style>
